import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';
import { getIsNewLine } from 'store/dealManagement/selectors';
import { getIsEditingDisabled } from 'store/dealManagement/selectors/getIsEditingDisabled';
import { getHasDealReadOnlyPermission } from 'store/dealManagement/selectors/getHasDealReadOnlyPermission';
import { isReadOnly } from 'utils/isReadOnly';

export const getDealFormReadOnly = createSelector(
  (state: Store) => state.dealManagement.commonDeal.bookingStatusCode,
  getIsEditingDisabled,
  (state: Store) => state.dealManagement.commonDeal.currentLine?.terminated,
  getIsNewLine,
  getHasDealReadOnlyPermission,
  (bookingStatusCode, isEditingDisabled, isLineTerminated, isNewLine, hasDealReadOnlyPermission) => {
    if (hasDealReadOnlyPermission) return true;

    return !isNewLine && isReadOnly(bookingStatusCode, isEditingDisabled, isLineTerminated);
  },
);
